"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styles = require("@qc-modules/styles");

var _container = _interopRequireDefault(require("../../legacy/container"));

var _primitives = _interopRequireDefault(require("../../primitives"));

var _components = require("../../components");

var _diagramModal = _interopRequireDefault(require("./diagram-modal"));

var _diagramPanel = _interopRequireDefault(require("./diagram-panel"));

var _utils = require("../../utils");

var _excluded = ["toggleShowModal", "rootElementId"],
    _excluded2 = ["image", "title", "darkUi", "titleColor"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var DiagramContainer = (0, _styledComponents["default"])(_container["default"]).withConfig({
  displayName: "diagram__DiagramContainer",
  componentId: "sc-164gi53-0"
})(["position:relative;background-color:", ";"], function (props) {
  return props.ui === "dark" ? (0, _styles.themeTransparentize)(1, "background", props) : (0, _styles.colors)("background", props);
});
var boxShadow = ["0 0 75px 0 rgba(74,90,117,0.01)", "0 19px 75px 0 rgba(74,90,117,0.1)", "inset 0 1px 1px 0 #f6f8fa", "inset 0 -1px 1px 0 #d4dce2"];
var Expand = (0, _styledComponents["default"])(_primitives["default"].Box).withConfig({
  displayName: "diagram__Expand",
  componentId: "sc-164gi53-1"
})(["cursor:pointer;fill:", ";position:absolute;top:16px;right:16px;", " &:hover{fill:", ";}"], function (props) {
  return (0, _styles.colors)(props.color, props);
}, (0, _styles.defaultTransition)(["fill"]), function (props) {
  return (0, _styles.themeDarken)(0.15, props.color, props);
});
var propTypes = {
  /** boolean for darkUI */
  darkUi: _propTypes.bool,

  /** Image source */
  image: _propTypes.node,

  /** Title text usually a text, but can be a React component  */
  title: _propTypes.node,

  /** title color */
  titleColor: _propTypes.string
};
var DiagramImageContainer = (0, _styledComponents["default"])(_diagramPanel["default"]).withConfig({
  displayName: "diagram__DiagramImageContainer",
  componentId: "sc-164gi53-2"
})(["flex:0 0 auto;min-height:100%;"]);

var DiagramModalContainer = function DiagramModalContainer(_ref) {
  var toggleShowModal = _ref.toggleShowModal,
      rootElementId = _ref.rootElementId,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement(_diagramModal["default"], {
    closeAction: /*#__PURE__*/_react["default"].createElement(Expand, {
      color: "icon-dark",
      display: "block",
      forwardedAs: "span",
      height: [36],
      onClick: toggleShowModal,
      width: [36]
    }, /*#__PURE__*/_react["default"].createElement(_components.NavClose, null)),
    handleEsc: toggleShowModal,
    root: rootElementId
  }, /*#__PURE__*/_react["default"].createElement(DiagramImageContainer, props));
};

DiagramModalContainer.propTypes = {
  /** root element id for diagram modal */
  rootElementId: _propTypes.string,

  /** function hook to toggle modal close on escape */
  toggleShowModal: _propTypes.func
};

var Diagram = function Diagram(_ref2) {
  var image = _ref2.image,
      title = _ref2.title,
      darkUi = _ref2.darkUi,
      titleColor = _ref2.titleColor,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded2);

  var defaultTitleColor = darkUi ? "text-light" : "title";
  var titleFont = {
    color: titleColor || defaultTitleColor,
    fontSize: [6, 6, 6, 6, 6, 6],
    fontWeight: 2,
    lineHeight: [2, 2, 1, 1, 1, 1],
    mb: 4,
    textAlign: "center"
  };

  var _useToggle = (0, _utils.useToggle)(false),
      shown = _useToggle[0],
      toggleShowModal = _useToggle[1];

  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(DiagramContainer, {
    alignItems: "center",
    borderRadius: [0, 18],
    boxShadow: [{}, boxShadow],
    flexDirection: "column",
    justifyContent: "center",
    maxWidth: 1000,
    pb: [0, 24, 64],
    pt: [24, 24, 5],
    px: [0, 24, 64]
  }, /*#__PURE__*/_react["default"].createElement(Expand, {
    color: "icon-input",
    display: "block",
    forwardedAs: "span",
    height: [0, 24],
    onClick: toggleShowModal,
    width: [0, 24]
  }, /*#__PURE__*/_react["default"].createElement(_components.NavLaunch, null)), /*#__PURE__*/_react["default"].createElement(DiagramImageContainer, _extends({
    image: image,
    title: title,
    titleFont: titleFont
  }, props))), shown && /*#__PURE__*/_react["default"].createElement(DiagramModalContainer, _extends({
    image: image,
    title: title,
    titleFont: titleFont,
    toggleShowModal: toggleShowModal
  }, props)));
};

Diagram.propTypes = propTypes;
Diagram.displayName = "Modules.Diagram";

var _default = (0, _styledComponents.withTheme)(Diagram);

exports["default"] = _default;